import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { UKOnlyMobileNumberInput } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isValidMobile } from '../../../utils/validation';

const BusinessNumber = ({ disabled = false, values }) => (
  <Content>
    {({
      businessContactDetailsTelLabel = '',
      businessContactDetailsTelError = '',
      vmContactUsUrl
    }) => (
      <Field name="businessNumber" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
         disabled ? <GenericDescriptionList
         items={[
           {key:businessContactDetailsTelLabel, value:values ?  values.businessNumber:''}
         ]} />: <GenericFieldWrapper
            name="businessNumber"
            title={businessContactDetailsTelLabel}
            validationMessage={touched && !!error ? businessContactDetailsTelError : ''}
          >
            <Field name="businessNumber" component="input" validate={isValidMobile}>
              {({ input }) => (
                <UKOnlyMobileNumberInput
                  id="businessNumber"
                  contactUsUrl={vmContactUsUrl}
                  {...input}
                  maxLength={11}
                  hasValidationEnabled={touched && !!error}
                  onChange={({ value }) => {
                    if (value && value.length > 11) return;
                    input.onChange(value);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>      
        )}
      </Field>
    )}
  </Content>
);

export default BusinessNumber;
